import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNominationMoveBackStudent({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M14.4 11a1 1 0 01.117 1.993L14.4 13h-3.9a1 1 0 01-.117-1.993L10.5 11h3.9zM5.696 5.397l.084.073 2 2a.75.75 0 01.073.976l-.073.084-2 2a.75.75 0 01-1.133-.976l.073-.084.722-.724-.066.004H1.424C.969 8.75.6 8.414.6 8c0-.38.31-.693.712-.743l.112-.007h3.952l.067.004-.723-.724a.75.75 0 01-.073-.976l.073-.084a.75.75 0 01.976-.073zM14.4 7a1 1 0 01.117 1.993L14.4 9h-3.9a1 1 0 01-.117-1.993L10.5 7h3.9zm0-4a1 1 0 01.117 1.993L14.4 5h-3.9a1 1 0 01-.117-1.993L10.5 3h3.9z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgNominationMoveBackStudent.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNominationMoveBackStudent.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgNominationMoveBackStudent svgRef={ref} {...props} />
));
export default ForwardRef;
